function variantUpdate() {
    document.addEventListener('productform:variant:update', (e) => {
        const variantDetails = e.detail;
        if(variantDetails && variantDetails.variant && variantDetails.variant.featured_image) {
            const mainProductImg = document.querySelector('.product-media-item');
            const currentVariantImg = document.querySelector(`[data-img-id="${variantDetails.variant.featured_media.id}"]`);
            if(!mainProductImg || !currentVariantImg) return;

            if(mainProductImg.dataset.imgId !== currentVariantImg.dataset.imgId) {
                const parent = mainProductImg.parentNode;
                const mainNext = mainProductImg.nextSibling === currentVariantImg
                ? mainProductImg
                : mainProductImg.nextSibling;

                parent.insertBefore(currentVariantImg, mainProductImg);
                parent.insertBefore(mainProductImg, mainNext);
            }

            // scroll to left for mobile screens
            if(window.matchMedia('(width <= 768px)').matches) document.querySelector('.product-media-container')?.scrollTo({left: 0});
        }
    })
}

document.addEventListener('DOMContentLoaded', variantUpdate);